import styled from "styled-components/macro";
export default styled.div`
  position: fixed;
  display: flex;
  flex-flow: column wrap;
  left: 20px;
  right: 20px;
  top: ${({ FollowUp }) =>
    FollowUp ? "calc(50% - 120px)" : "calc(50% - 100px)"};
  z-index: 2000;
  height: ${({ FollowUp }) => (FollowUp ? "200px" : "150px")};
  overflow-y: auto;
  padding: 10px 0 0 0;
  border-radius: 10px;
  background: #eff4f6;
  justify-content: space-between;
  overflow: hidden;
  & h3 {
    color: #038696;
    font-size: 15px;
    font-weight: 400;
    padding: 0 10px;
    line-height: 30px;
    margin: 0;
  }
  & .selectWrapper {
    flex-basis: 40px;
    max-height: 40px;
    padding: 0 10px;
  }
  & .selectWrapper select {
    height: 40px;
    width: 100%;
    background: #fff;
    border-radius: 5px;
    border-color: var(--color1);
  }
  & .btn_Wrapper {
    display: flex;
    flex-wrap: wrap row;
    flex-basis: 50px;
    max-height: 50px;
    align-items: stretch;
    margin: 0;
    padding: 0;
  }
  & .btn {
    flex: 0 0 50%;
    max-width: 50%;
    text-align: center;
    font-size: 19px;
    border: unset;
    color: #fff;
    background: var(--color2);
    margin: 0;
    padding: 0;
  }
  & .btn.cancel {
    background: var(--failed);
  }
`;
